class headerMenuHandler extends HTMLElement {
  constructor() {
    super();

    this.menuholder = this.querySelector('.vertical-menu__items');
    this.button = this.querySelector('.vertical-menu__show-more');

    // data-extra-height may be missing or not a number
    const extra = Number(this.getAttribute('data-extra-height'));
    this.extra_height = Number.isFinite(extra) ? extra : 0;

    // Bind once
    this.resizeMenuEvent = this.resizeMenuEvent.bind(this);
    this.clickHandler = this.clickHandler.bind(this);

    // If required elements are missing, do not attach handlers
    // (prevents crashes on templates without vertical menu markup)
    if (!this.menuholder) return;

    Shopify.designMode ? setTimeout(this.resizeMenu.bind(this), 400) : false;

    this.createEvents();

    if (!Shopify.designMode) {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(this.resizeMenu.bind(this), 200);
        setTimeout(this.resizeMenu.bind(this), 1000);
      });

      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          setTimeout(this.resizeMenu.bind(this), 200);
        }
      });
    }
  }

  resizeMenu() {
    const main_content = document.getElementById('MainContent');
    if (!main_content) return;
    if (!this.menuholder) return;

    const data_menu_opened = document.querySelector('[data-menu-opened]');
    const rect = this.menuholder.getBoundingClientRect();
    const items_top_position = window.scrollY + rect.top;

    // main_content.children exists even if empty, but guard anyway
    if (!main_content.children || !main_content.children.length) return;

    this.querySelectorAll('.hidden-menu-item').forEach((item) => {
      item.classList.remove('hidden-menu-item');
    });

    const openedByDefault = main_content.classList.contains('menu-opened-by-default');

    if (data_menu_opened || openedByDefault) {
      // If there is no [data-menu-opened], do NOT try to read attributes from it
      // Fall back to default height behaviour
      if (!data_menu_opened) {
        this.renderItems(items_top_position, 620);
        this.hasAttribute('hide-before-load') && this.removeAttribute('hide-before-load');
        return;
      }

      const index = Number(data_menu_opened.getAttribute('data-menu-opened')) - 1;

      // Guard invalid index
      if (!Number.isFinite(index) || index < 0 || index >= main_content.children.length) {
        this.renderItems(items_top_position, 620);
        this.hasAttribute('hide-before-load') && this.removeAttribute('hide-before-load');
        return;
      }

      const section_height = window.scrollY + main_content.children[index].getBoundingClientRect().bottom;
      const menu_top_position =
        (this.closest('.menu-opened-by-default') ? 0 : window.scrollY) + this.getBoundingClientRect().top;

      let height = section_height - menu_top_position;

      if (this.closest('.menu-opened-by-default')) {
        height = Math.min(height, this.menuholder.offsetHeight + 20);
        height = height < -1 ? this.menuholder.offsetHeight + 20 : height;
      }

      this.style.height = '100%';
      this.style.minHeight = (height + this.extra_height) + 'px';
      this.renderItems(items_top_position, height);
    } else {
      this.renderItems(items_top_position, 620);
    }

    this.hasAttribute('hide-before-load') && this.removeAttribute('hide-before-load');
  }

  renderItems(items_top_position, height) {
    if (!this.menuholder) return;
    if (!this.menuholder.children || !this.menuholder.children.length) {
      if (this.button) this.button.classList.add('hide');
      return;
    }

    let hide_item = true;
    const first = this.menuholder.children[0];
    const offsetmain = first ? first.offsetTop : 0;

    for (let i = this.menuholder.children.length - 1; i >= 0; i--) {
      const item = this.menuholder.children[i];
      const y = item.offsetTop + offsetmain + item.offsetHeight;

      if (this.menuholder.children.length - 1 === i && y <= height) {
        if (this.button) this.button.classList.add('hide');
        return;
      } else if (y > height) {
        if (this.button && this.button.classList.contains('hide')) this.button.classList.remove('hide');
        item.classList.add('hidden-menu-item');
      } else {
        if (hide_item) {
          hide_item = false;
          if (this.button && y > height - this.button.offsetHeight - 15) {
            item.classList.add('hidden-menu-item');
          }
        }
      }
    }
  }

  resizeMenuEvent() {
    setTimeout(this.resizeMenu.bind(this), 800);
  }

  createEvents() {
    window.addEventListener('resize', this.resizeMenuEvent);
    if (this.button) {
      this.button.addEventListener('click', this.clickHandler);
    }
  }

  clickHandler() {
    if (!this.button) return;

    if (this.button.classList.contains('active')) {
      this.classList.remove('menu-show-items');
      setTimeout(this.hideItems.bind(this), 0);
    } else {
      this.classList.add('menu-opened');
      this.button.classList.add('active');
      setTimeout(this.showItems.bind(this), 0);
    }
  }

  showItems() {
    this.classList.add('menu-show-items');
  }

  hideItems() {
    this.classList.remove('menu-opened');
    if (this.button) this.button.classList.remove('active');
    window.dispatchEvent(new Event('forStickyHeader'));
  }
}

customElements.define('vertical-menu', headerMenuHandler);